import { render, staticRenderFns } from "./Editer.vue?vue&type=template&id=188484d6&scoped=true"
import script from "./Editer.vue?vue&type=script&lang=js"
export * from "./Editer.vue?vue&type=script&lang=js"
import style0 from "./Editer.vue?vue&type=style&index=0&id=188484d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188484d6",
  null
  
)

export default component.exports